import { Button } from "@/components/ui/button";
import { Pencil, Trash2 } from "lucide-react";
import { useUser } from "@/context/UserContext";

export const RowActions = ({ idx, onEdit, onDelete, extra }) => {
  const { canWrite } = useUser();
  if (!canWrite) return null;
  return (
    <div className="flex items-center justify-end gap-1 whitespace-nowrap">
      {extra}
      <Button
        size="icon"
        variant="ghost"
        onClick={onEdit}
        data-testid={`row-edit-${idx}`}
        className="h-8 w-8 text-[#5C6B7B] hover:text-[#0D1B2A]"
      >
        <Pencil size={15} strokeWidth={1.75} />
      </Button>
      <Button
        size="icon"
        variant="ghost"
        onClick={onDelete}
        data-testid={`row-delete-${idx}`}
        className="h-8 w-8 text-[#5C6B7B] hover:text-[#9B2226]"
      >
        <Trash2 size={15} strokeWidth={1.75} />
      </Button>
    </div>
  );
};
